import { render, staticRenderFns } from "./flow-demo.vue?vue&type=template&id=f6b85f14&scoped=true&"
import script from "./flow-demo.vue?vue&type=script&lang=js&"
export * from "./flow-demo.vue?vue&type=script&lang=js&"
import style0 from "./flow-demo.vue?vue&type=style&index=0&id=f6b85f14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b85f14",
  null
  
)

export default component.exports